module.exports = __webpack_public_path__ + "img/close_white.2ba22493.svg";